import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/http/auth/auth.service';
import { UserService } from 'src/app/shared/services/http/user/user.service';
import { MatDialog } from '@angular/material/dialog';
import { RegistrationRequiredComponent } from 'src/app/home/popup/registration-required/registration-required.component';
import { DialogRegistrationsClosedComponent } from './dialog-registrations-closed/dialog-registrations-closed.component';
import { HostListener } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util/util.service';
import { CartService } from 'src/app/shared/services/cart/cart.service';
import { AppConfig } from 'src/app/config/app.config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  AppConfig = AppConfig;
  token:any=''
  userDetails:any
  userData: any
  public timedOutCloser:any;
  public targetMenuTrigger:any;
  isDropdownOpen = false;
  currentRoute: string = '';
  addToCartCount: number = 0;
  constructor(private dialog: MatDialog, private authService: AuthService, private router: Router, private service: UserService, private utilService: UtilService, private cartService: CartService) { }

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
      // console.log('Current route:', this.currentRoute);
    });
    
    this.token=this.authService.getToken()
    if(this.token){
      this.userDetails=this.authService.getDataFromLocalStorage('user_details')
      this.userDetails=JSON.parse(this.userDetails)
    //  console.log(this.userDetails)
     if(this.userDetails?.registrationNo){

     
      this.service.getProfiledata(this.userDetails?.registrationNo).subscribe((res:any)=>{
          this.userData=res.data;
          this.service.userData.next(res);
        })
      }
    }

    this.cartService.addToCartSubject.subscribe(count => this.addToCartCount = count);
  
    // Refresh count in case of page reload
    this.cartService.refreshCartCount();

  }

  logout(): void {
    localStorage.clear();
    const kc = environment.keycloak;
    window.location.href =
      `${kc.url}realms/${kc.realm}/protocol/openid-connect/logout` +
      `?post_logout_redirect_uri=${encodeURIComponent(environment.MAIN_PLATFORM_URL)}` +
      `&client_id=${kc.clientId}`;
  }

  shouldShowButton(): boolean {   
    return !this.router.isActive('/exam-managment', true);
  }

  RegistrationRequired() {
    if( this.userData?.student?.paymentStatus ==='failed' || this.userData?.student?.paymentStatus ==='pending'){
      const dialogRef = this.dialog.open(RegistrationRequiredComponent, {
        width: '500px',
        data: {
          message: 'Hello World from Edupala',
        },
      }); 
      //dialogRef.close();
      // setTimeout(() => {
      //   dialogRef.close();
      // }, 5000);
    }else {
        this.router.navigate(['/exam-managment']);
    }
    
    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('The dialog was closed');
    // });
   
  }

  openDialog(): void {
    this.dialog.open(DialogRegistrationsClosedComponent, {
      width: "490px",
    });
  }

  mouseEnter(trigger:any) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }

  mouseLeave(trigger:any) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const dropdownElement = (event.target as HTMLElement).closest('.position-relative');
    const cartButton = (event.target as HTMLElement).closest('.btn-cart');
    if (!dropdownElement || cartButton) {
      this.isDropdownOpen = false;
    }
  }

  addToCart() {
    this.router.navigate(['/student/my-cart']);
  }

  onPurchaseHistory(){
    if(this.userDetails?.type != 'institute'){
      this.router.navigate(['/student/purchase-history']);
    }else{
      this.router.navigate(['/institute/payment-history']);
    }
    this.toggleDropdown();
  }

  onMyProfile() {
    this.router.navigate(['/student/edit']);
    this.toggleDropdown();
  }
}
